<script>
    import { onMount, createEventDispatcher } from 'svelte'

    export let value = ''

    const dispatch = createEventDispatcher ();


</script>

<style>
    .PeriodSelector {
        height: 30px;
        padding: 0;
        border-radius: 0;
        border: 0;
        outline: 0;
        font-size: 14px;
        font-weight: 600;
        color: #586d7d;
        /* background-color: #dbe4ea; */
        -webkit-appearance: none;
        border-radius: 2px;
        background-color: var(--sidelink-hover);
        position: relative;
    }
    .PeriodSelector .arrow, .PeriodSelector .value {
        float: left;
    }
    .PeriodSelector .arrow {
        border: none;
        width: 20%;
        background-color: unset;
        -webkit-appearance: none;
        line-height: 31px;
        padding: 0 10px;
        outline: none;
    }
    .PeriodSelector .arrow.left {
        text-align: left;
    }
    .PeriodSelector .arrow.right {
        text-align: right;
    }
    .PeriodSelector .arrow:active {
        background-color: #dce7ec;
    }
    .PeriodSelector .value {
        width: 60%;
        line-height: 29px;
        text-align: center;
    }
</style>

<div class="PeriodSelector clearfix">
    <button class="arrow left" on:click={e => dispatch ('month-change', 'prev')}>
        <i class="far fa-arrow-left"></i>
    </button>
    <div class="value">{value}</div>
    <button class="arrow right" on:click={e => dispatch ('month-change', 'next')}>
        <i class="far fa-arrow-right"></i>
    </button>
</div>